import { compose } from 'ramda'

/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */

export default class Renderer {
  /**
   *  This method is a shorthand expression of immediate function invocation syntax with condition in JSX.
   *
   *  ```
   *  {(() => {
   *      return condition ? (<div></div>) : null
   *  })()}
   *  ```
   *
   *  ```
   *  import r from './Renderer'
   *  r.renderIf(condition)(<div></div>)
   *  ```
   *
   */
  static renderIf = condition => compose(x => (condition ? x : null))
  static renderIfOrElse = condition => x => compose(y => (condition ? x : y))
}
